import { useEffect } from 'react'
import queryString from 'query-string'
import { Heading, Skeleton, Text, VStack } from '@ritualco/jutsu'
import { useConfirmPermissionTicket } from 'api/endpoints/permissionTicket'
import { useGetWorkspaceAdminInviteDetails } from 'api/endpoints/portalAdmins'
import { CardPage } from 'components/PageTemplates'
import { WorkspaceChangeProps } from 'hooks/useWorkspaceChange'
import { useContent } from 'lib/content/react'
import { useLocation } from 'lib/router'
import { selectUserInfo } from 'state/selectors/userInfo'
import { useStore } from 'state/store'

export type AdminInviteConfirmProps = {
  onWorkspaceChange?: (ids: WorkspaceChangeProps) => void
}

const AdminInviteConfirm = ({
  onWorkspaceChange = () => {},
}: AdminInviteConfirmProps) => {
  const location = useLocation()
  const { formatMessage } = useContent()
  const { firstName } = useStore(selectUserInfo)
  const setRitualLogoType = useStore(state => state.setRitualLogoType)
  const confirm = useConfirmPermissionTicket()

  const parsed = queryString.parse(location.search)
  const { accessCode } = parsed
  const { data } = useGetWorkspaceAdminInviteDetails({
    invitationId: parsed.accessCode as string,
  })

  useEffect(() => {
    if (typeof accessCode === 'string' && data) {
      confirm.mutate(
        { ticketId: accessCode },
        {
          onSuccess: () => {
            onWorkspaceChange({
              organizationId: data.inviterOrganizationId as string,
              workspaceId: data.inviterWorkspaceId as string,
            })
          },
        }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    setRitualLogoType(data?.inviterOrganizationType)
  }, [data?.inviterOrganizationType, setRitualLogoType])

  return (
    <CardPage>
      <VStack spacing={3} mb={6}>
        <Skeleton isLoaded={!!firstName}>
          <Text fontSize="small" lineHeight="small">
            {formatMessage(
              { id: 'pmportal.landing.welcome' },
              { name: firstName }
            )}
          </Text>
        </Skeleton>
        <Heading as="h1" fontSize="3xlarge" lineHeight="3xlarge">
          {formatMessage({ id: 'pmportal.landing.connecting' })}
        </Heading>
      </VStack>
    </CardPage>
  )
}

export default AdminInviteConfirm
